import regexps from '../../../../utils/regexps';

const schema = {
    situation: {
        id: 'situation',
        label: 'Situação',
        required: true,
        help: '',
        options: '',
        value: '',
    },
    demissionDate: {
        id: 'demissionDate',
        label: 'Data de desligamento/aposentadoria',
        required: true,
        help: '',
    },
    radioContribution: {
        id: 'radioContribution',
        label: '',
        value: 'I',
        required: true,
        help: '',
    },
    contributionDate: {
        id: 'contributionDate',
        label: 'Data',
        required: true,
        help: '',
    },
    contributionYears: {
        id: 'contributionYears',
        label: 'Ano',
        required: false,
        disabled: true,
        regex: regexps.numbers,
        help: '',
    },
    contributionMonths: {
        id: 'contributionMonths',
        label: 'Mês',
        required: false,
        disabled: true,
        regex: regexps.numbers,
        help: '',
    },
    contributionDays: {
        id: 'contributionDays',
        label: 'Dia',
        required: false,
        disabled: true,
        regex: regexps.numbers,
        help: '',
    },
    stayCompany: {
        id: 'stayCompany',
        label: 'Período de Permanência no DAP',
        required: true,
        disabled: true,
        help: '',
    },
    dueDate: {
        id: 'dueDate',
        label: 'Dia de vencimento',
        disabled: true,
        regex: regexps.numbers,
        help: '',
    },
    observation: {
        id: 'observation',
        label: 'Observação',
        required: false,
        help: '',
        value: '',
    },
};

export default schema;
